export default {
  default: 'default',
  primary: 'primary',
  secondary: 'secondary',
  link: 'link',
  defaultOutlined: 'default-outlined',
  primaryOutlined: 'primary-outlined',
  secondaryOutlined: 'secondary-outlined',
}
